/**
 * card wrapper component
 * including number/password/...
 */
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { faAngleUp, IconDefinition, faAngleDown } from "@fortawesome/free-solid-svg-icons";

export enum Mode {
    bodyOnly = 'bodyOnly',
    normal = 'normal',
}

@Component({
    selector: 'card',
    template: `
        <section class="card card-margin-outside" [ngClass]="generatedClassList">
            <header *ngIf="mode !== 'bodyOnly'"
                    class="header"
                    [class.em]="isEmphasis"
                    [class.flex-header]="isCollapsible"
                    [ngClass]="{'headerClass': showDistinctClasses}">
                <ng-content select=".card-header-content"></ng-content>
                <btn class="toggle-button"
                     *ngIf="isCollapsible"
                     type="actionHeaderLink"
                     (click)="toggleContent()">
                    <fa-icon [icon]="showContent ? iconAngleUp : iconAngleDown" class="icon"></fa-icon>
                </btn>
            </header>

            <ng-container *ngIf="showContent">
                <ng-content select=".card-sub-header-content"></ng-content>
            </ng-container>

            <div class="body"
                 [ngClass]="{'bodyClass': showDistinctClasses}"
                [class.no-footer]="!hasFooter"
                [class.body-only]="mode === 'bodyOnly'"
                 [class.bodyPadding]="isBodyPadding"
                 [class.bodyFlex]="isBodyFlex"
                 *ngIf="showContent">
                <ng-content select=".card-body-content"></ng-content>
            </div>

            <footer *ngIf="mode !== 'bodyOnly' && showContent && hasFooter"
                    class="footer"
                    [class.alignRight]="isFooterRightAlign"
                    #footerContainer>
                <ng-content select=".card-footer-content"></ng-content>
            </footer>
        </section>
    `,
    styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnChanges {

    @Input()
    public showContent: boolean = true;
    @Output()
    public readonly showContentChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input()
    public isEmphasis: boolean = false;
    @Input()
    public mode: Mode = Mode.normal;
    @Input()
    public isCollapsible: boolean = false;
    @Input()
    public classList: string;
    @Input()
    public isScrollable: boolean = false;
    @Input()
    public isFooterRightAlign: boolean = false;
    @Input()
    public isBodyPadding: boolean = false;
    @Input()
    public isBodyFlex: boolean = false;
    @Input()
    public hasFooter: boolean = true;
    @Input()
    public showDistinctClasses: boolean = false;

    public readonly iconAngleUp: IconDefinition = faAngleUp;
    public readonly iconAngleDown: IconDefinition = faAngleDown;

    public generatedClassList: string;

    public ngOnChanges(changes: SimpleChanges): void {
        this.generatedClassList = this.getClassList();
    }

    public toggleContent(): void {
        this.showContent = !this.showContent;
        this.showContentChange.emit(this.showContent);
    }

    public getClassList(): string {
        return [
            this.classList,
            this.isScrollable ? "scrollable" : undefined
        ].filter(Boolean)
            .join(' ');
    }
}
